import { isProd } from "config/env";
import { PropsWithChildren } from "react";
import { CookieBanner } from "./elements/CookieBanner/CookieBanner";
import { DebugPanel } from "./elements/DebugPanel/DebugPanel";
import { VersionLabel } from "./elements/VersionLabel/VersionLabel";
import { Global } from "@emotion/react";
import { globalStyles } from "../../config/globalStyles";
import { GlobalStore } from "../../store/global/GlobalStore";

export const AppWrapper = ({ children }: PropsWithChildren) => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <>
      <Global styles={globalStyles(theme)} />
      {children}
      <CookieBanner />

      {!isProd && (
        <>
          <DebugPanel />
          <VersionLabel />
        </>
      )}
    </>
  );
};
